import { NoConnectionService } from './../../pages/no-connection/no-connection.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { ErrorHandlingService } from '@common/services/error-handling.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { WathiqErrorCode } from '@common/enums/wathiq-error-code.enum';
import { FirebaseRemoteConfigService } from '@common/services/firebase-remote-config.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private alertService: ErrorHandlingService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private noConnectionService: NoConnectionService,
    // wathiq_rollback - Inject FirebaseRemoteConfigService for centralized wathiq flow status
    private firebaseRemoteConfigService: FirebaseRemoteConfigService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const params: string | undefined = this.router.parseUrl(this.router.url)
      .queryParams['token'];
    return next.handle(request).pipe(
      catchError((httpError: HttpErrorResponse) => {
        const error = this.getErrorMessage(httpError);

        if (httpError?.status === 0) {
          this.noConnectionService.cachedRequest.next(request);
        } else if (httpError?.status === 503) {
          this.alertService.maintenanceMode.next(true);
        } else if (httpError?.status === 504) {
          // Show as unexpected error
          this.alertService.showError({});
        } else if (
          httpError?.status === 401 &&
          (!request.url.includes('kyc') || !params)
        ) {
          this.router.navigate(['/auth/login']);
          localStorage.removeItem('step');
        } else if (
          httpError?.status === 401 &&
          request.url.includes('kyc') &&
          params
        ) {
          const queryParams: Params = { refresh: 'true' };

          this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams,
            queryParamsHandling: 'merge', // remove to replace all query params by provided
          });
        }

        // wathiq_rollback - Check if this is a Wathiq-specific error code
        // wathiq_rollback - Only handle Wathiq errors if flow is enabled (using centralized signal)
        const errorCode = error?.code || error?.errorCode;
        const isWathiqError =
          this.firebaseRemoteConfigService.turn_on_watheeq_flow() &&
          (errorCode === WathiqErrorCode.AttemptsLimitExceeded ||
            errorCode === WathiqErrorCode.NoResultFound ||
            errorCode === WathiqErrorCode.FailedToIntegrate);

        // wathiq_rollback - Only show error toast if it's not a Wathiq-specific error (when flow is enabled)
        if (!isWathiqError) {
          this.alertService.showError(error);
        }

        return throwError(error);
      })
    );
  }

  private getErrorMessage(error: HttpErrorResponse) {
    return error?.error;
  }
}
